import { LoginResponseDto } from "src/store/auth/types";

export const CheckPermission = (
  user?: LoginResponseDto,
  permission?: string[]
) => {
  // if (permission && user) {
  //   return user.Permissions.some((a) => permission.some((y) => y === a));
  // } else
  return true;
};
